<template>
  <div class="tasks" :style="no_result ? 'height: 100%' : ''">
    <AddTasks
      :project_id="project_id"
      :project_name="project_name"
      v-if="$route.path != '/search'"
    />

    <div
      class="tasks_body"
      v-if="search_result != ''"
      :style="no_result ? 'height: 100%' : ''"
    >
      <div v-if="no_result" class="search_no_result">
        <p>{{ $t("task.not_tasks") }}</p>
        <!-- <svg width="163" height="120" viewBox="0 0 163 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2_81997)">
                        <path d="M2.57001 54.54L13.44 60.88" stroke="#0077FF" stroke-width="5.13" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M22.41 53.39C22.41 53.39 14.41 53.06 16.46 58.15C14.8538 58.9571 13.5 60.1895 12.5461 61.713C11.5921 63.2365 11.0746 64.9926 11.05 66.79C11.05 72.95 14.56 73.79 14.56 73.79C15.1919 74.9541 16.2458 75.8319 17.505 76.2429C18.7641 76.654 20.1329 76.567 21.33 76C21.33 76 29.33 78.2 29.24 70.4C29.24 70.4 33.24 67.4 28.47 61.69C29.0042 60.4618 29.0968 59.0867 28.7323 57.7979C28.3677 56.5092 27.5684 55.3863 26.47 54.62L22.41 53.39Z" fill="white"/>
                        <path d="M69.71 86C69.71 86 74.99 85.87 73.08 91.32C73.08 91.32 77.44 113.71 74.08 116.88C70.72 120.05 48 123.43 48 112.73C48 112.73 48.66 101.94 59.7 101.94C59.7 101.94 61.58 91.94 61.18 91.39C60.78 90.84 59.13 90.5 59.68 88.02C60.23 85.54 64.93 85.37 64.93 85.37L69.71 86Z" fill="white"/>
                        <path d="M23.68 59.08C23.4739 59.083 23.2684 59.056 23.07 59C22.7719 58.92 22.4924 58.782 22.2476 58.5939C22.0028 58.4058 21.7975 58.1714 21.6433 57.9039C21.4892 57.6365 21.3892 57.3413 21.3492 57.0352C21.3092 56.7291 21.3298 56.4181 21.41 56.12C25.22 41.99 33.07 34.12 38.98 30.12C42.6751 27.4831 46.8448 25.585 51.26 24.53C51.8726 24.4146 52.506 24.5474 53.0208 24.899C53.5356 25.2506 53.8896 25.7924 54.005 26.405C54.1204 27.0177 53.9876 27.651 53.636 28.1658C53.2844 28.6806 52.7426 29.0346 52.13 29.15C48.2915 30.125 44.6738 31.8219 41.47 34.15C33.91 39.36 28.68 47.19 26 57.34C25.8621 57.8469 25.559 58.2932 25.1388 58.6084C24.7186 58.9236 24.2052 59.0895 23.68 59.08Z" fill="white"/>
                        <path d="M66.59 89.74C65.5 89.74 65.01 89.49 65 89.09C64.76 80.96 66.11 73.09 66.4 72.74C67.2676 72.21 68.2998 72.0178 69.3 72.2C70.55 72.32 71.3 72.75 70.93 73.2C69.6549 78.2954 69.2059 83.5623 69.6 88.8C69.6 89.26 68.35 89.68 67.08 89.8L66.59 89.74Z" fill="white"/>
                        <path d="M29.13 70.47C28.8309 70.6094 28.5049 70.6817 28.175 70.6817C27.845 70.6817 27.519 70.6094 27.22 70.47" stroke="#D8D8D8" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M27 68.22C27.0244 69.5178 27.1921 70.809 27.5 72.07" stroke="#D8D8D8" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M21.33 75.93C21.33 75.93 16.18 71.93 19.05 66.69" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M14.57 73.68C14.0451 72.4676 13.8236 71.1455 13.9247 69.8282C14.0258 68.511 14.4463 67.2382 15.15 66.12" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M59.79 101.9C59.79 101.9 69.25 101.82 71.72 105.35" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M98.31 86C98.31 86 93 85.85 94.93 91.3C94.93 91.3 90.57 113.69 93.93 116.86C97.29 120.03 120.04 123.43 120.04 112.73C120.04 112.73 119.39 101.94 108.34 101.94C108.34 101.94 106.47 91.94 106.87 91.39C107.27 90.84 108.87 90.5 108.37 88.02C107.87 85.54 103.11 85.37 103.11 85.37L98.31 86Z" fill="white"/>
                        <path d="M101.43 89.74C102.51 89.74 103 89.49 103.01 89.09C103.26 80.96 101.9 73.09 101.61 72.74C100.742 72.21 99.7102 72.0178 98.71 72.2C97.46 72.32 96.71 72.75 97.09 73.2C98.365 78.2954 98.8141 83.5623 98.42 88.8C98.42 89.26 99.67 89.68 100.94 89.8L101.43 89.74Z" fill="white"/>
                        <path d="M108.22 101.9C108.22 101.9 98.76 101.82 96.29 105.35" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M151 53.52C151 53.52 159.05 53.19 156.95 58.28C158.557 59.0866 159.913 60.3187 160.868 61.8421C161.824 63.3655 162.343 65.1219 162.37 66.92C162.37 73.09 158.85 73.92 158.85 73.92C158.221 75.0876 157.169 75.9697 155.91 76.3846C154.65 76.7994 153.279 76.7155 152.08 76.15C152.08 76.15 144.08 78.35 144.18 70.56C144.18 70.56 140.18 67.56 144.94 61.85C144.41 60.6213 144.319 59.2473 144.683 57.9595C145.048 56.6717 145.845 55.5489 146.94 54.78L151 53.52Z" fill="white"/>
                        <path d="M149.74 59.22C149.947 59.2188 150.152 59.1885 150.35 59.13C150.95 58.9662 151.461 58.571 151.77 58.0311C152.08 57.4912 152.162 56.8507 152 56.25C148.19 42.12 140.34 34.25 134.42 30.25C130.728 27.6098 126.557 25.7145 122.14 24.67C121.834 24.6079 121.519 24.6072 121.214 24.668C120.908 24.7289 120.617 24.85 120.358 25.0243C120.1 25.1986 119.878 25.4226 119.707 25.6834C119.536 25.9441 119.419 26.2363 119.362 26.5429C119.305 26.8495 119.309 27.1643 119.375 27.4692C119.441 27.774 119.567 28.0627 119.745 28.3184C119.924 28.5741 120.151 28.7917 120.415 28.9585C120.678 29.1253 120.972 29.238 121.28 29.29C125.119 30.2636 128.737 31.9606 131.94 34.29C139.5 39.57 144.72 47.4 147.46 57.56C147.609 58.0461 147.912 58.4707 148.323 58.77C148.734 59.0694 149.232 59.2272 149.74 59.22Z" fill="white"/>
                        <path d="M144.29 70.6C144.587 70.7399 144.912 70.8125 145.24 70.8125C145.568 70.8125 145.893 70.7399 146.19 70.6" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M146.4 68.35C146.375 69.6472 146.211 70.9379 145.91 72.2" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M152.08 76.07C152.08 76.07 157.24 72.07 154.37 66.82" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M158.85 73.82C159.372 72.6064 159.591 71.2842 159.488 69.9672C159.385 68.6502 158.964 67.378 158.26 66.26" stroke="#0077FF" stroke-width="0.24" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M26.57 69L37.53 75.39" stroke="#0077FF" stroke-width="5.13" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M49.52 1.44C50.62 13.86 51.52 26.81 52.08 40.27C52.68 54.17 52.92 67.55 52.88 80.39L108.15 80.68L121 72.25L122.19 1.53C98.0103 -0.496668 73.7047 -0.52677 49.52 1.44ZM54.52 12.54C54.6235 11.9685 54.9497 11.4614 55.427 11.1304C55.9043 10.7994 56.4935 10.6716 57.065 10.775C57.6366 10.8784 58.1436 11.2047 58.4746 11.682C58.8056 12.1592 58.9335 12.7485 58.83 13.32C58.7554 13.7472 58.5546 14.1422 58.2533 14.4541C57.9521 14.766 57.5643 14.9805 57.14 15.07C56.786 15.1524 56.417 15.1453 56.0663 15.0495C55.7157 14.9536 55.3944 14.772 55.1315 14.521C54.8685 14.27 54.6722 13.9574 54.5602 13.6116C54.4483 13.2658 54.4241 12.8975 54.49 12.54H54.52ZM55.6 28.9C55.7035 28.3285 56.0297 27.8214 56.507 27.4904C56.9843 27.1594 57.5735 27.0316 58.145 27.135C58.7166 27.2384 59.2236 27.5647 59.5546 28.042C59.8856 28.5192 60.0135 29.1085 59.91 29.68C59.8315 30.1082 59.6283 30.5036 59.3258 30.8167C59.0234 31.1299 58.6352 31.3467 58.21 31.44C57.8578 31.5151 57.4924 31.5021 57.1464 31.4023C56.8003 31.3024 56.4843 31.1188 56.2262 30.8676C55.968 30.6164 55.7759 30.3054 55.6667 29.9622C55.5574 29.619 55.5345 29.2542 55.6 28.9ZM60.85 65.9C60.7809 66.2905 60.607 66.6548 60.347 66.9542C60.087 67.2536 59.7506 67.4768 59.3736 67.5999C58.9967 67.7231 58.5934 67.7415 58.2068 67.6534C57.8202 67.5653 57.4647 67.3738 57.1784 67.0995C56.8921 66.8251 56.6856 66.4782 56.5811 66.0957C56.4765 65.7132 56.4778 65.3095 56.5847 64.9276C56.6916 64.5458 56.9002 64.2001 57.1882 63.9276C57.4762 63.655 57.8329 63.4657 58.22 63.38C58.573 63.2989 58.9407 63.3071 59.2898 63.4037C59.6388 63.5004 59.9583 63.6825 60.2194 63.9336C60.4804 64.1847 60.6748 64.4969 60.7849 64.842C60.895 65.187 60.9174 65.5541 60.85 65.91V65.9ZM60.57 46.84C60.5009 47.2305 60.327 47.5948 60.067 47.8942C59.807 48.1936 59.4706 48.4168 59.0936 48.5399C58.7167 48.6631 58.3134 48.6815 57.9268 48.5934C57.5402 48.5053 57.1847 48.3138 56.8984 48.0395C56.6121 47.7651 56.4056 47.4182 56.3011 47.0357C56.1965 46.6532 56.1978 46.2495 56.3047 45.8676C56.4116 45.4858 56.6202 45.1401 56.9082 44.8676C57.1962 44.595 57.5529 44.4057 57.94 44.32C58.2927 44.2416 58.6593 44.2516 59.0072 44.3492C59.355 44.4469 59.6733 44.629 59.9337 44.8795C60.1941 45.13 60.3884 45.441 60.4995 45.7848C60.6105 46.1286 60.6347 46.4945 60.57 46.85V46.84Z" fill="white"/>
                        <path d="M108.15 80.68C108.691 79.0082 109.099 77.2961 109.37 75.56C109.654 73.7208 109.782 71.8608 109.75 70C113.335 71.4182 117.145 72.1804 121 72.25C119.093 73.67 117.05 75.1 114.87 76.54C112.557 78.0467 110.317 79.4267 108.15 80.68Z" fill="#0077FF"/>
                        <path d="M61.46 12.58C79.05 11.22 104.35 12.1 121.95 13.3" stroke="#0077FF" stroke-width="1.28" stroke-miterlimit="10"/>
                        <path d="M62.07 29.22C62.9 29.15 103.72 28.7 121.67 29.96" stroke="#0077FF" stroke-width="1.28" stroke-miterlimit="10"/>
                        <path d="M62.82 46.17C80.39 44.81 103.82 45.63 121.39 46.89" stroke="#0077FF" stroke-width="1.28" stroke-miterlimit="10"/>
                        <path d="M63.67 65.68C81.29 64.32 103.44 65.23 121.05 66.55" stroke="#0077FF" stroke-width="1.28" stroke-miterlimit="10"/>
                        <path d="M60.18 0.690002C61.41 13.27 62.18 24.09 62.77 37.89C63.44 52.74 63.65 66.95 63.5 80.46" stroke="#0077FF" stroke-width="0.64" stroke-miterlimit="10"/>
                        <path d="M69.49 7.77C69.7773 7.29387 70.1124 6.84823 70.49 6.44C70.8552 6.05402 71.2461 5.6932 71.66 5.36C72.4622 4.70608 73.3342 4.14267 74.26 3.68C75.1872 3.20386 76.1628 2.82838 77.17 2.56C77.692 2.41693 78.2233 2.31001 78.76 2.24C79.3325 2.15538 79.9125 2.13191 80.49 2.17L80.57 2.32L79.22 3.06L77.85 3.77L75.12 5.2L72.36 6.57L71 7.26L69.6 7.92L69.49 7.77Z" fill="#0077FF"/>
                        <path d="M56.35 107.11C68.329 107.11 78.04 97.3991 78.04 85.42C78.04 73.4409 68.329 63.73 56.35 63.73C44.3709 63.73 34.66 73.4409 34.66 85.42C34.66 97.3991 44.3709 107.11 56.35 107.11Z" fill="white" stroke="#0077FF" stroke-width="3.48" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M72.2 42.06C72.2 42.06 86.8 29.06 102.55 42.67" stroke="#0077FF" stroke-width="0.71" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M103 40.94C103 40.94 103.61 42.57 101.53 44.21" stroke="#0077FF" stroke-width="0.71" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M71.79 40.4C71.79 40.4 71.12 42.01 73.12 43.73" stroke="#0077FF" stroke-width="0.71" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M94.2 5.07001C94.7584 5.00952 95.3216 5.00952 95.88 5.07001C96.4056 5.13398 96.9266 5.23084 97.44 5.36001C98.4433 5.62164 99.4156 5.99043 100.34 6.46001C101.284 6.93114 102.176 7.50099 103 8.16001C103.425 8.49554 103.829 8.85618 104.21 9.24001C104.614 9.65325 104.975 10.1055 105.29 10.59L105.22 10.75L103.82 10.1L102.43 9.42001L99.62 8.07001L96.87 6.66001L95.49 6.00001L94.13 5.27001L94.2 5.07001Z" fill="#0077FF"/>
                        <path d="M99.8 24C99.8 24 100.32 25.91 98.42 25.87C96.52 25.83 97.3 23.66 97.3 23.66L99.8 24Z" fill="white"/>
                        <path d="M74.51 35.07C78.6908 35.07 82.08 30.8346 82.08 25.61C82.08 20.3854 78.6908 16.15 74.51 16.15C70.3292 16.15 66.94 20.3854 66.94 25.61C66.94 30.8346 70.3292 35.07 74.51 35.07Z" fill="white" stroke="#0077FF" stroke-width="0.74" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M74.51 29.05C76.0619 29.05 77.32 27.4069 77.32 25.38C77.32 23.3531 76.0619 21.71 74.51 21.71C72.9581 21.71 71.7 23.3531 71.7 25.38C71.7 27.4069 72.9581 29.05 74.51 29.05Z" fill="#0077FF"/>
                        <path d="M75.05 24.25C75.7182 24.25 76.26 23.7083 76.26 23.04C76.26 22.3717 75.7182 21.83 75.05 21.83C74.3817 21.83 73.84 22.3717 73.84 23.04C73.84 23.7083 74.3817 24.25 75.05 24.25Z" fill="white"/>
                        <path d="M100.92 34.84C105.101 34.84 108.49 30.6046 108.49 25.38C108.49 20.1554 105.101 15.92 100.92 15.92C96.7392 15.92 93.35 20.1554 93.35 25.38C93.35 30.6046 96.7392 34.84 100.92 34.84Z" fill="white" stroke="#0077FF" stroke-width="0.74" stroke-miterlimit="10" stroke-linecap="round"/>
                        <path d="M100.92 28.83C102.472 28.83 103.73 27.1869 103.73 25.16C103.73 23.1331 102.472 21.49 100.92 21.49C99.3681 21.49 98.11 23.1331 98.11 25.16C98.11 27.1869 99.3681 28.83 100.92 28.83Z" fill="#0077FF"/>
                        <path d="M101.46 24.03C102.128 24.03 102.67 23.4883 102.67 22.82C102.67 22.1517 102.128 21.61 101.46 21.61C100.792 21.61 100.25 22.1517 100.25 22.82C100.25 23.4883 100.792 24.03 101.46 24.03Z" fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2_81997">
                            <rect width="162.37" height="120" fill="white"/>
                        </clipPath>
                    </defs>
                </svg> -->
      </div>

      <div
        v-else
        class="vertical_scrollbar"
        style="height: 100vh; padding: 0 15px"
      >
        <div
          v-for="tasks in search_result"
          :key="tasks.project"
          style="margin-bottom: 15px"
        >
          <h2 class="search_res__project_name">{{ tasks.project }}</h2>
          <div class="draggable_tasks">
            <Task
              v-for="task in search_tasks[tasks._id]"
              :key="task._id"
              :task="task"
              @change_complete="change_complete"
              @delete_task="delete_task"
              :done="task.done"
              :search="true"
              :chat_id="chat_id"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="tasks_body" v-else>
      <!--  group="Task" v-bind="dragOptions" @change="onEndTaskDrop" -->
      <!-- @change="onEndTaskDrop" -->
      <draggable
        :list="uncompleted_tasks"
        @start="drag = true"
        @add="drag = true"
        group="Task"
        @change="onEndTaskDrop"
        v-bind="dragOptions"
        class="draggable_tasks draggable_tasks__height"
      >
        <!-- :class="!drag ? 'list-complete__item' : ''" -->
        <transition-group
          type="transition"
          :name="!drag ? 'list-complete' : null"
          class="draggable_tasks_group"
        >
          <Task
            v-for="task in uncompleted_tasks"
            :key="task._id"
            :task="task"
            @delete_task="delete_task"
            @change_complete="change_complete"
            :chat_id="chat_id"
            :class="!drag ? 'list-complete__item' : ''"
          />
        </transition-group>
      </draggable>

      <draggable
        v-model="project_sections"
        group="Section"
        v-bind="dragOptions"
        @change="changeOrderSection"
        class="draggable_tasks"
      >
        <transition-group type="transition" class="draggable_tasks_group">
          <Section
            v-for="section in project_sections"
            :key="section._id"
            :section="section"
            :tasks="sections_tasks"
            @removeSection="removeSection"
            :chat_id="chat_id"
            :project_id="project_id"
          ></Section>
        </transition-group>
      </draggable>

      <div
        class="tasks__hide-show_completed-task"
        v-if="$route.path != '/search'"
      >
        <button @click="addSection">
          {{ $t("task.add_section") }}
        </button>
        <div>
          <button
            @click="showCompletedTask"
            v-if="completed_tasks.filter((a) => a.parent == '').length > 0"
          >
            {{
              show_completed_task
                ? $t("task.hide_completed", { num: completed_tasks.length })
                : $t("task.show_completed", { num: completed_tasks.length })
            }}
          </button>
          <button
            @click="showCompletedRecurringTask"
            v-if="recur_tasks.length > 0"
          >
            {{
              show_completed_recurring_task
                ? $t("task.hide_recurring", { num: recur_tasks.length })
                : $t("task.show_recurring", { num: recur_tasks.length })
            }}
          </button>
        </div>
      </div>

      <!-- <NestedTasks v-model="uncompleted_tasks" /> -->
      <div
        v-if="
          show_completed_task && completed_tasks && completed_tasks.length > 0
        "
        class="draggable_completed_tasks"
      >
        <transition-group
          v-if="animation_tasks"
          type="transition"
          name="list-complete"
        >
          <Task
            v-for="task in completed_tasks"
            :key="task._id"
            :task="task"
            @delete_task="delete_task"
            @change_complete="change_complete"
            :chat_id="chat_id"
            class="list-complete__item_done"
          />
        </transition-group>
        <template v-else>
          <Task
            v-for="task in completed_tasks"
            :key="task._id"
            :task="task"
            @delete_task="delete_task"
            @change_complete="change_complete"
            :chat_id="chat_id"
            class="list-complete__item_done"
          />
        </template>
      </div>

      <div
        v-if="
          show_completed_recurring_task && recur_tasks && recur_tasks.length > 0
        "
        class="draggable_completed_tasks recur-completed_tasks"
      >
        <transition-group
          v-if="animation_tasks"
          type="transition"
          name="list-complete"
        >
          <Task
            v-for="task in recur_tasks"
            :key="task._id"
            :task="task"
            @delete_task="delete_task"
            @change_complete="change_complete"
            :chat_id="chat_id"
            class="list-complete__item_done"
          />
        </transition-group>
        <template v-else>
          <Task
            v-for="task in recur_tasks"
            :key="task._id"
            :task="task"
            @delete_task="delete_task"
            @change_complete="change_complete"
            :chat_id="chat_id"
            class="list-complete__item_done"
          />
        </template>
      </div>
    </div>
    <ContextMenu />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AddTasks from "./AddTasks";
import Task from "./Task";
import draggable from "vuedraggable";
import NestedTasks from "./NestedTasks";
import { EventEmitter } from "../../main";
import Section from "./Section.vue";
import ContextMenu from "./ContextMenu.vue";

export default {
  name: "Tasks",
  props: {
    project_id: [String],
    project_name: [String],
    chat_id: [String],
  },
  data() {
    return {
      drag: true,
      task_id: "",
      recur_tasks: [],
      uncompleted_tasks: [],
      uncompleted_tasks_length: "",
      completed_tasks: [],
      sections_tasks: [],
      search_result: [],
      search_tasks: [],
      no_result: false,
      show_completed_task: false,
      show_completed_recurring_task: false,
      project_sections: [],
      this_user_change_order: true,
      chats_project_id: "",
      search_text: "",
      recur: [],
      animation_tasks: true,
    };
  },
  mounted() {
    this.$root.$on("openRecur", () => {
      this.animation_tasks = false;
      this.show_completed_recurring_task = true;
      this.show_completed_task = false;
      setTimeout(() => {
        this.animation_tasks = true;
      }, 100);
    });

    // if (!this.$route.params.task_id) {
    setTimeout(() => {
      this.drag = false;
    }, 1000);
    // }

    this.no_task();

    EventEmitter.$on("openCompletedBlock", (data) => {
      if (this.chats_project_id == data.project_id) {
        if (this.$route.params.task_id == data.task_id) {
          this.show_completed_task = true;
        }
      }
    });

    EventEmitter.$on("removeSection", (section_id) => {
      this.removeSection(section_id);
    });

    EventEmitter.$on("TaskMove_DeleteTask", (task_id) => {
      if (this.uncompleted_tasks) {
        this.uncompleted_tasks.forEach((e, i) => {
          if (e._id == task_id) {
            this.uncompleted_tasks.splice(i, 1);
          }
        });
      }
      if (this.completed_tasks) {
        this.completed_tasks.forEach((e, i) => {
          if (e._id == task_id) {
            this.completed_tasks.splice(i, 1);
          }
        });
      }
      // this.onEndTaskDrop()

      setTimeout(() => {
        let new_order = [];
        this.uncompleted_tasks.forEach((e, i) => {
          if (e) {
            new_order.push({
              task_id: e._id,
              order: i,
            });
          }
        });

        const new_order_position = {
          out: true,
          new_order: new_order,
          project_id: this.chats_project_id,
        };

        // this.socket_change_order({ new_order_position, add_global: true })
      }, 2000);
    });

    EventEmitter.$on("TaskChangeOrder", (data) => {
      if (data == this.chats_project_id) {
        // alert(0)
        setTimeout(() => {
          let new_order = [];
          this.uncompleted_tasks.forEach((e, i) => {
            new_order.push({
              task_id: e._id,
              order: i,
            });
          });

          const new_order_position = {
            out: true,
            new_order: new_order,
            project_id: this.chats_project_id,
          };

          this.socket_change_order({ new_order_position, add_global: true });
        }, 2000);
      }
    });

    if (this.$route.params.project_id) {
      this.chats_project_id = this.$route.params.project_id;
    } else {
      this.chats_project_id = this.project_id
        ? this.project_id
        : this.$route.params.project_id;
    }

    if (this.getCompletedTasks[this.chats_project_id]) {
      let task = this.getCompletedTasks[this.chats_project_id].filter(
        (e) => e._id == this.$route.params.task_id
      );
      if (task.length > 0) {
        this.show_completed_task = true;
      }
    }

    // console.log(localStorage.getItem('project_id'), this.chats_project_id)

    let sections = this.getProjects.filter(
      (e) => e._id == this.chats_project_id
    );
    // console.log(sections)
    if (sections.length > 0) {
      if (sections[0].sections) {
        let section = [];
        sections[0].sections.forEach((e) => {
          section[e.order] = e;
        });
        let filtered = section.filter(function (el) {
          return el != null;
        });
        this.project_sections = filtered;
      }
    }
    // console.log(this.project_sections)
    // if (this.project_sections) {
    this.project_sections.forEach((e) => {
      this.sections_tasks[e._id] = [];
    });
    // }

    EventEmitter.$on("AnimeTask", () => {
      // let tasks = this.uncompleted_tasks
      // this.uncompleted_tasks = ''
      // this.uncompleted_tasks = tasks
    });

    EventEmitter.$on("SectionProject", (data) => {
      let sections2 = this.getProjects.filter((e) => e._id == data);
      if (sections2[0].sections) {
        let section2 = [];
        sections2[0].sections.forEach((e) => {
          section2[e.order] = e;
        });
        let filtered = section2.filter(function (el) {
          return el != null;
        });
        this.project_sections = filtered;
      }
    });

    // this.getProjects.forEach((e) => {
    //     if (e._id == this.chats_project_id) {
    //         this.project_sections = e.sections
    //     } else {
    //         this.project_sections = []
    //     }
    // })

    // console.log(this.uncompleted_tasks)

    EventEmitter.$on("changeOrder", (data) => {
      setTimeout(() => {
        this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
        let local_section = this.sections_tasks;
        if (data) {
          // if (this.this_user_change_order) {
          if (data.evt != undefined) {
            if (data.evt.removed) {
              if (data.section_id) {
                local_section[data.section_id].forEach((task, i) => {
                  if (task._id == data.evt.removed.element._id) {
                    local_section[data.section_id].splice(i, 1);
                  }
                });
              } else {
                this.uncompleted_tasks.forEach((task, i) => {
                  if (task._id == data.evt.removed.element._id) {
                    this.uncompleted_tasks.splice(i, 1);
                  }
                });
              }
            }

            if (data.evt.added) {
              if (data.section_id) {
                this.getTasks[data.project_id].forEach((task, i) => {
                  if (task._id == data.evt.added.element._id) {
                    local_section[data.section_id].push(task);
                  }
                });
                // this.getTasks[data.project_id].forEach((e, i) => {
                //     if (e._id == data.evt.added.element._id) {
                //         this.getTasks[data.project_id][i].section = data.section_id
                //     }
                // })
                // this.project_sections.forEach((e) => {
                //     local_section[e._id] = []
                // })

                // this.uncompleted_tasks = []
                // this.fill_tasks_array(this.getTasks, this.getCompletedTasks)
              } else {
                this.getTasks[data.project_id].forEach((task, i) => {
                  if (task._id == data.evt.added.element._id) {
                    this.uncompleted_tasks.push(task);
                    // this.uncompleted_tasks.forEach((e) => {
                    //     if (e._id != task._id) {
                    //         this.uncompleted_tasks.push(task)
                    //     }
                    // })
                  }
                });
              }
            }

            if (data.evt.moved) {
              if (data.section_id) {
                EventEmitter.$emit("changeSectionTaskOrder", data);
              } else {
                let tasks = this.getTasks[data.project_id];
                tasks.forEach((task, task_index) => {
                  if (data.new_order.length > 0) {
                    data.new_order.forEach((new_data) => {
                      if (task._id == new_data.task_id) {
                        tasks[task_index].order = new_data.order;
                      }
                    });
                  }
                });

                this.getTasks[data.project_id] = tasks;

                this.project_sections.forEach((e) => {
                  local_section[e._id] = [];
                });

                this.uncompleted_tasks = [];
                this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
              }
            }
          }

          // } else {
          //     setTimeout(() => {
          //         this.this_user_change_order = true
          //     }, 500)
          // }
        }
        this.sections_tasks = [];
        this.sections_tasks = local_section;
      }, 500);
    });

    EventEmitter.$on("WatchSectionTasks", (data) => {
      this.sections_tasks[data.section_id] = data.tasks;
    });

    EventEmitter.$on("TaskDone", (data) => {
      if (data) {
        if (data.done) {
          this.uncompleted_tasks.forEach((e, i) => {
            if (e._id == data.task_id) {
              e.done = true;
              this.completed_tasks = [e].concat(this.completed_tasks);
            }
          });
          this.uncompleted_tasks = this.uncompleted_tasks.filter(
            (item) => item._id !== data.task_id
          );
          this.getTasks[this.chats_project_id] = this.uncompleted_tasks;
          this.getCompletedTasks[this.chats_project_id] = this.completed_tasks;
        } else {
          this.completed_tasks.forEach((e, i) => {
            if (e._id == data.task_id) {
              e.done = false;
              this.uncompleted_tasks = [e].concat(this.uncompleted_tasks);
            }
          });
          this.completed_tasks = this.completed_tasks.filter(
            (item) => item._id !== data.task_id
          );
          this.getCompletedTasks[this.chats_project_id] = this.completed_tasks;
          this.getTasks[this.chats_project_id] = this.uncompleted_tasks;
        }
      }
    });

    EventEmitter.$on("changeSectionOrder", (data) => {
      if (data) {
        if (data.project_id == this.chats_project_id) {
          let section = [];
          this.project_sections.forEach((e) => {
            data.sections.forEach((out) => {
              if (out._id == e._id) {
                section[e.order] = e;
              }
            });
          });
          let filtered = section.filter(function (el) {
            return el != null;
          });
          this.project_sections = filtered;
        }
      }
    });

    EventEmitter.$on("change_task_order_after_filter", (data) => {
      this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
    });

    EventEmitter.$on("delete_project_filter_option", (data) => {
      this.delete_project_filter_option();
    });

    EventEmitter.$on("removeTaskfromSection", (data) => {
      let newTask = Object.values(this.getCompletedTasks[data.project_id]).find(
        (task) => task._id == data.task_id
      );
      newTask.completed_date = String(new Date().getTime());
      this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
    });

    EventEmitter.$on("SearchTasksProject", (data) => {
      this.search_text = data;
      if (data == "") {
        this.no_result = false;
        this.search_result = "";
        // let a = document.getElementsByClassName('project_title')
        // if (this.$route.path != '/search') {
        //     document.getElementsByClassName('project_title')[0].style.display = 'flex'
        // }
      } else {
        this.renderSearch(data);
        // document.getElementsByClassName('project_title')[0].style.display = 'none'
      }
    });

    EventEmitter.$on("RenderSearch", () => {
      setTimeout(() => {
        this.renderSearch(this.search_text);
      }, 1000);
    });
  },
  methods: {
    ...mapActions([
      "fetch_tasks",
      "socket_change_order",
      "socket_completed_task",
      "socket_change_order_after_done",
    ]),
    ...mapMutations([
      "setTasks",
      "clearComments",
      "set_active_task_window",
      "changeCommentLoading",
      "setMessage",
      "set_change_task",
    ]),
    no_task() {
      setTimeout(() => {
        if (this.$route.params.task_id) {
          let is_task = this.getTasks[this.$route.params.project_id]
            ? this.getTasks[this.$route.params.project_id].filter(
                (e) => this.$route.params.task_id == e._id
              )
            : "";
          let is_done_task = this.getCompletedTasks[
            this.$route.params.project_id
          ]
            ? this.getCompletedTasks[this.$route.params.project_id].filter(
                (e) => this.$route.params.task_id == e._id
              )
            : "";
          if (is_task.length == 0 && is_done_task.length == 0) {
            let data = {
              type: "no_task",
              data: {
                text: this.$t("task.task_not_exist"),
                cancel: this.$t("app.alert.close"),
                delete: "",
              },
              list: this.$route.params.task_id,
            };
            EventEmitter.$emit("OpenPopup", data);
            this.$router.push("/project/" + this.$route.params.project_id);
          }
        } else {
        }

        this.fill_tasks_array(this.getTasks, this.getCompletedTasks);

        this.uncompleted_tasks_length = this.uncompleted_tasks.length;
      }, 100);
    },
    removeSection({ section_id, remove_tasks }) {
      this.project_sections = this.project_sections.filter(
        (e) => e._id != section_id
      );

      if (remove_tasks) {
        this.sections_tasks[section_id] = [];
      } else {
        if (this.sections_tasks[section_id]) {
          if (this.sections_tasks[section_id].length != 0) {
            this.sections_tasks[section_id].forEach((task, i) => {
              task.section = "";
              task.order = this.uncompleted_tasks.length + i;
              // console.log(task)
              this.uncompleted_tasks.push(task);
            });
          }
        }

        let done_task = this.completed_tasks.filter(
          (e) => e.section == section_id
        );

        if (done_task.length != 0) {
          done_task.forEach((task, i) => {
            task.section = "";
          });
        }

        let tasks = this.uncompleted_tasks;
        let new_order = [];

        tasks.forEach((e, i) => {
          new_order.push({
            task_id: e._id,
            order: i,
          });
        });

        const new_order_position = {
          out: true,
          new_order: new_order,
          project_id: this.chats_project_id,
        };

        this.this_user_change_order = false;
        this.socket_change_order({ new_order_position, add_global: true });
      }
    },
    addSection() {
      let w_bool = false;

      this.$w_plan(
        this,
        this.getPlan,
        "section",
        () => {
          this.setMessage({
            key_message: "warning",
            message: this.$planMessages.section.en,
            plan: true,
          });
          w_bool = true;
        },
        this.chats_project_id
      );

      if (w_bool) {
        return;
      }

      let id = this.$w_decrypt(this.getUserData._id);
      let section = this.project_sections;
      let order = [];

      if (section.length > 0) {
        section.forEach((e) => {
          order.push(e.order);
        });
      } else {
        order = 0;
      }

      section.push({
        _id: id,
        name: "",
        order: order == 0 ? 1 : Math.max.apply(null, order) + 1,
        new: true,
      });
      this.project_sections = section;
      this.sections_tasks[id] = [];
    },
    fill_tasks_array(getTasks, getCompletedTasks) {
      let recurs = this.recur.length > 0 ? this.recur : this.get_recur;

      this.uncompleted_tasks = [];
      this.sections_tasks = [];
      this.recur_tasks = [];
      this.project_sections.forEach((e) => {
        this.sections_tasks[e._id] = [];
      });
      if (getTasks[this.chats_project_id]) {
        recurs = recurs.filter((recur) => recur.completed == true);
        // recurs = recurs.filter(recur => recur.enabled != false)
        getTasks[this.chats_project_id].forEach((e) => {
          if (e) {
            let recur = recurs.find((recur) => recur.task_id == e._id);
            if (recur) {
              if (recur.completed) {
                e.done = recur.completed;
                e.completed_date = recur.completed_date
                  ? recur.completed_date
                  : "0";
                this.recur_tasks.push(e);
              }
            } else {
              if (!e.parent && !e.section) {
                this.uncompleted_tasks.push(e);
              } else if (e.section != "" && e.parent == "") {
                this.project_sections.forEach((a) => {
                  if (e.section == a._id) {
                    this.sections_tasks[a._id].push(e);
                  }
                });
              }
            }
          }
        });
        this.uncompleted_tasks.sort(function (a, b) {
          return a.order - b.order;
        });
      }

      if (
        Object.keys(getCompletedTasks).length > 0 &&
        getCompletedTasks[this.chats_project_id]
      ) {
        let un = [];
        un = getCompletedTasks[this.chats_project_id].sort((a, b) => {
          if (!b.hasOwnProperty("completed_date")) {
            b.completed_date = "0";
          }
          if (!a.hasOwnProperty("completed_date")) {
            a.completed_date = "0";
          }
          if (
            b.hasOwnProperty("completed_date") &&
            a.hasOwnProperty("completed_date")
          ) {
            return b.completed_date - a.completed_date;
          }
        });
        this.completed_tasks = un;
      }

      if (this.recur_tasks.length > 0) {
        this.recur_tasks.sort((a, b) => {
          return b.completed_date - a.completed_date;
        });
      }

      let tasks = this.uncompleted_tasks;
      this.uncompleted_tasks = [];
      this.uncompleted_tasks = tasks;
    },
    changeOrderSection(evt) {
      let sections = this.project_sections;
      let new_order = [];

      sections.forEach((e, i) => {
        new_order.push({
          _id: e._id,
          order: i,
        });
      });

      const new_order_position = {
        sections: new_order,
        project_id: this.chats_project_id,
        evt: evt,
      };

      this.$socket.emit("IN_SectionOrder", new_order_position);
    },
    onEndTaskDrop(evt) {
      console.log("order");
      // this.fill_tasks_array(this.getTasks, this.getCompletedTasks)
      EventEmitter.$emit("TaskMove", "");
      document.querySelectorAll(".move-task").forEach((element) => {
        element.classList.remove("move-task");
      });

      setTimeout(() => {
        this.drag = false;
      }, 200);

      let tasks = this.uncompleted_tasks;
      let new_order = [];

      tasks.forEach((e, i) => {
        if (e) {
          new_order.push({
            task_id: e._id,
            order: i,
          });
        }
      });

      const new_order_position = {
        out: true,
        new_order: new_order,
        project_id: this.chats_project_id,
        evt: evt,
      };

      // this.set_change_task({
      //     list_id: this.chats_project_id,
      //     tasks: this.uncompleted_tasks
      // })

      this.socket_change_order({ new_order_position, add_global: true });
    },
    change_complete({ complete, task_id, list_id }) {
      if (complete) {
        this.show_completed_task = true;
      }

      this.socket_completed_task({
        complete,
        task_id: task_id,
        project_id: list_id,
      });

      // if (this.search_text) {

      //     // this.renderSearch(this.search_text)

      //     let search_tasks = this.search_tasks
      //     this.search_result.forEach((e, i) => {
      //         search_tasks[e._id].forEach((t, z) => {
      //             if (t._id == task_id) {
      //                 search_tasks[e._id][z].done = complete
      //             }
      //         })
      //     })

      //     this.search_tasks = []
      //     // setTimeout(() => {
      //         this.search_tasks = search_tasks
      //     // }, 1)

      // }
    },
    delete_task({ project_id, task_id }) {
      // const new_order_position = {
      //     out: true,
      //     new_order: this.$w_change_order("delete", this.getTasks[this.chats_project_id], {task_id}),
      //     project_id,
      // };
      // this.socket_change_order({ new_order_position, add_global: true });
      let new_order = [];
      this.uncompleted_tasks.forEach((e, i) => {
        new_order.push({
          task_id: e._id,
          order: i,
        });
      });

      const new_order_position = {
        out: true,
        new_order: new_order,
        project_id: this.chats_project_id,
      };

      this.socket_change_order({ new_order_position, add_global: true });
    },
    delete_project_filter_option() {
      this.getProjects.forEach((project) => {
        if (project) {
          if (project._id == this.project_id) {
            this.$socket.emit("IN_ListsOrderBy", {
              list_id: project._id,
              order_by: "",
            });
          }
        }
      });
    },
    renderSearch(data) {
      let res = [];
      let tasks = [];

      if (document.querySelector(".main-content")) {
        document
          .querySelector(".main-content")
          .classList.remove("chat-background");
        document.querySelector(".main-content").style.backgroundImage = "";
      }

      this.getProjects.forEach((p) => {
        if (p._id) {
          let task = "";
          let CompletedTasks = "";

          if (this.getTasks[p._id]) {
            task = this.getTasks[p._id].filter((e) => {
              return e.name.toLowerCase().includes(data.toLowerCase());
            });
          }

          if (this.getCompletedTasks[p._id]) {
            CompletedTasks = this.getCompletedTasks[p._id].filter((e) => {
              return e.name.toLowerCase().includes(data.toLowerCase());
            });
          }

          if (task != "") {
            if (CompletedTasks != "") {
              CompletedTasks.forEach((e) => {
                task.push(e);
              });
            }
          } else {
            if (CompletedTasks != "") {
              res.push({
                project: p.name,
                _id: p._id,
              });
              tasks[p._id] = CompletedTasks;
            }
          }

          if (task != "") {
            res.push({
              project: p.name,
              _id: p._id,
            });
            tasks[p._id] = task;
          }
        }
      });

      if (res.length > 0) {
        this.search_result = res;
        this.search_tasks = tasks;
        this.no_result = false;
      } else {
        this.no_result = true;
        this.search_result = "s";
        this.search_tasks = [];
      }
    },
    showCompletedRecurringTask() {
      this.animation_tasks = false;
      this.show_completed_recurring_task = !this.show_completed_recurring_task;
      this.show_completed_task = false;
      setTimeout(() => {
        this.animation_tasks = true;
      }, 100);
    },
    showCompletedTask() {
      this.animation_tasks = false;
      this.show_completed_task = !this.show_completed_task;
      this.show_completed_recurring_task = false;
      setTimeout(() => {
        this.animation_tasks = true;
      }, 100);
    },
  },
  computed: {
    ...mapGetters([
      "getTasks",
      "getProjects",
      "getComments",
      "getCompletedTasks",
      "get_flag_for_tasks",
      "getSubTask",
      "getUserData",
      "getPlan",
      "get_flag_task_done",
      "get_recur",
    ]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        removeCloneOnHide: true,
      };
    },
    // nested_tasks: {
    //     get() {
    //         // return this.uncompleted_tasks;
    //     },
    //     set(value) {
    //         console.log("nested_tasks", value);
    //     },
    // },
  },
  watch: {
    get_flag_for_tasks() {
      let sections = this.getProjects.filter(
        (e) => e._id == this.chats_project_id
      );
      if (sections.length > 0) {
        if (sections[0].sections) {
          let section2 = [];
          sections[0].sections.forEach((e) => {
            section2[e.order] = e;
          });
          let filtered = section2.filter(function (el) {
            return el != null;
          });
          this.project_sections = filtered;
        } else {
          this.project_sections = [];
        }
      }
      this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
    },
    $route(to) {
      this.no_task();

      this.drag = true;

      // if (!this.$route.params.task_id) {
      setTimeout(() => {
        this.drag = false;
      }, 1000);
      // }

      if (this.getCompletedTasks[to.params.project_id]) {
        let tasks = this.getCompletedTasks[to.params.project_id].filter(
          (e) => e.parent == ""
        );
        let task = tasks.filter((e) => e._id == to.params.task_id);
        if (task.length > 0) {
          this.show_completed_task = true;
        }
      }

      this.chats_project_id = this.project_id
        ? this.project_id
        : this.$route.params.project_id;
      this.uncompleted_tasks = [];
      this.completed_tasks = [];

      let sections = this.getProjects.filter(
        (e) => e._id == this.chats_project_id
      );
      // console.log(sections)
      if (sections.length > 0) {
        if (sections[0].sections) {
          let section2 = [];
          sections[0].sections.forEach((e) => {
            section2[e.order] = e;
          });
          let filtered = section2.filter(function (el) {
            return el != null;
          });
          this.project_sections = filtered;
        } else {
          this.project_sections = [];
        }
      }

      this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
    },
    get_flag_task_done() {
      this.onEndTaskDrop({});
    },
    "$store.state.tasks.recur": {
      async handler(v) {
        this.recur = v;
        console.log("recur", v);
        this.fill_tasks_array(this.getTasks, this.getCompletedTasks);
        // let recurs = v.filter(e => e.list_id == this.chats_project_id)
        // recurs = recurs.map(e => {
        //     let task = this.getTasks[this.chats_project_id].find(t => t._id == e.task_id)
        //     if (task) return task
        // })
        // console.log(recurs)
      },
      deep: true,
    },
  },
  components: {
    AddTasks,
    Task,
    NestedTasks,
    draggable,
    Section,
    ContextMenu,
  },
};
</script>
